import React from 'react';
import {Typography} from '@mui/material';

import RenderRecordingComponent from './RenderRecordingComponent';

const NO_ZOOM_LINK_MESSAGE = "No link available";

const RenderZoomLinkCell = (params) => {
    if (!params.row.sessionId) {
      return <Typography variant="body2">{NO_ZOOM_LINK_MESSAGE}</Typography>;
    }
  
    return <RenderRecordingComponent sessionId={params.row.sessionId} />;
};

export default RenderZoomLinkCell;